"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var DictionaryTermsContext = /*#__PURE__*/(0, _react.createContext)({
  dictionaryTerms: [],
  setDictionaryTerms: function setDictionaryTerms() {}
});
var _default = DictionaryTermsContext;
exports["default"] = _default;